export const loaders = {
"./ai-manager/index.svelte": () => import("./ai-manager/index.svelte"),
"./android-management/index.svelte": () => import("./android-management/index.svelte"),
"./contacts/addresses.svelte": () => import("./contacts/addresses.svelte"),
"./contacts/distributions.svelte": () => import("./contacts/distributions.svelte"),
"./database-manager/audit.svelte": () => import("./database-manager/audit.svelte"),
"./database-manager/backups.svelte": () => import("./database-manager/backups.svelte"),
"./database-manager/documents.svelte": () => import("./database-manager/documents.svelte"),
"./database-manager/migrations.svelte": () => import("./database-manager/migrations.svelte"),
"./dms/access.svelte": () => import("./dms/access.svelte"),
"./dms/akten.svelte": () => import("./dms/akten.svelte"),
"./dms/documents.svelte": () => import("./dms/documents.svelte"),
"./dms/jobs.svelte": () => import("./dms/jobs.svelte"),
"./drucksachen/beschriftungslabels.svelte": () => import("./drucksachen/beschriftungslabels.svelte"),
"./drucksachen/index.svelte": () => import("./drucksachen/index.svelte"),
"./hausmeister-manager/active-tasks.svelte": () => import("./hausmeister-manager/active-tasks.svelte"),
"./hausmeister-manager/aufwandsanalyse.svelte": () => import("./hausmeister-manager/aufwandsanalyse.svelte"),
"./hausmeister-manager/tasks.svelte": () => import("./hausmeister-manager/tasks.svelte"),
"./hausmeister-manager/missstaende.svelte": () => import("./hausmeister-manager/missstaende.svelte"),
"./hausmeister-manager/fortschritt.svelte": () => import("./hausmeister-manager/fortschritt.svelte"),
"./hausmeister-manager/team-stundenzettel.svelte": () => import("./hausmeister-manager/team-stundenzettel.svelte"),
"./hausmeister-manager/termine.svelte": () => import("./hausmeister-manager/termine.svelte"),
"./hausmeister-manager/tonnenservice.svelte": () => import("./hausmeister-manager/tonnenservice.svelte"),
"./hausmeister-manager/demnaechst.svelte": () => import("./hausmeister-manager/demnaechst.svelte"),
"./hausmeister-worker/aktiv.svelte": () => import("./hausmeister-worker/aktiv.svelte"),
"./hausmeister-worker/aufgaben.svelte": () => import("./hausmeister-worker/aufgaben.svelte"),
"./hausmeister-worker/demnaechst.svelte": () => import("./hausmeister-worker/demnaechst.svelte"),
"./hausmeister-worker/kiosk.svelte": () => import("./hausmeister-worker/kiosk.svelte"),
"./hausmeister-worker/missstaende.svelte": () => import("./hausmeister-worker/missstaende.svelte"),
"./hausmeister-worker/stundenzettel.svelte": () => import("./hausmeister-worker/stundenzettel.svelte"),
"./hausmeister-worker/termine.svelte": () => import("./hausmeister-worker/termine.svelte"),
"./hausmeister-worker/tonnen.svelte": () => import("./hausmeister-worker/tonnen.svelte"),
"./impower-migration/bearbeitung.svelte": () => import("./impower-migration/bearbeitung.svelte"),
"./impower-migration/fortschritt.svelte": () => import("./impower-migration/fortschritt.svelte"),
"./impower-migration/prueffaelle.svelte": () => import("./impower-migration/prueffaelle.svelte"),
"./impower-migration/recherche.svelte": () => import("./impower-migration/recherche.svelte"),
"./impower-migration/zuweisung.svelte": () => import("./impower-migration/zuweisung.svelte"),
"./invoices/circles.svelte": () => import("./invoices/circles.svelte"),
"./invoices/debug-invoice-repair.svelte": () => import("./invoices/debug-invoice-repair.svelte"),
"./invoices/invoices.svelte": () => import("./invoices/invoices.svelte"),
"./invoices/profiles.svelte": () => import("./invoices/profiles.svelte"),
"./invoices/templates.svelte": () => import("./invoices/templates.svelte"),
"./kfz/fleet.svelte": () => import("./kfz/fleet.svelte"),
"./kfz/settings.svelte": () => import("./kfz/settings.svelte"),
"./letters/batches.svelte": () => import("./letters/batches.svelte"),
"./letters/letters.svelte": () => import("./letters/letters.svelte"),
"./letters/outbox.svelte": () => import("./letters/outbox.svelte"),
"./letters/settings.svelte": () => import("./letters/settings.svelte"),
"./letters/stationery.svelte": () => import("./letters/stationery.svelte"),
"./letters/templates.svelte": () => import("./letters/templates.svelte"),
"./metering/auswertung.svelte": () => import("./metering/auswertung.svelte"),
"./metering/einladung.svelte": () => import("./metering/einladung.svelte"),
"./metering/erfassung.svelte": () => import("./metering/erfassung.svelte"),
"./metering/jahresablesung.svelte": () => import("./metering/jahresablesung.svelte"),
"./metering/proposals.svelte": () => import("./metering/proposals.svelte"),
"./metering/werte.svelte": () => import("./metering/werte.svelte"),
"./metering/zaehlernummern.svelte": () => import("./metering/zaehlernummern.svelte"),
"./mitarbeiter/abwesenheiten.svelte": () => import("./mitarbeiter/abwesenheiten.svelte"),
"./mitarbeiter/arbeitszeit.svelte": () => import("./mitarbeiter/arbeitszeit.svelte"),
"./mitarbeiter/arbeitszeit-regeln.svelte": () => import("./mitarbeiter/arbeitszeit-regeln.svelte"),
"./mitarbeiter/mein-stand.svelte": () => import("./mitarbeiter/mein-stand.svelte"),
"./mitarbeiter/mitarbeiter.svelte": () => import("./mitarbeiter/mitarbeiter.svelte"),
"./mitarbeiter/team-arbeitszeit.svelte": () => import("./mitarbeiter/team-arbeitszeit.svelte"),
"./mitarbeiter/urlaubskonten.svelte": () => import("./mitarbeiter/urlaubskonten.svelte"),
"./objekte/karte.svelte": () => import("./objekte/karte.svelte"),
"./objekte/settings.svelte": () => import("./objekte/settings.svelte"),
"./objekte/stammdaten.svelte": () => import("./objekte/stammdaten.svelte"),
"./prozesse/index.svelte": () => import("./prozesse/index.svelte"),
"./scanner/admin.svelte": () => import("./scanner/admin.svelte"),
"./scanner/scanner.svelte": () => import("./scanner/scanner.svelte"),
"./schluessel/adapter-und-geraete.svelte": () => import("./schluessel/adapter-und-geraete.svelte"),
"./schluessel/ausgabe.svelte": () => import("./schluessel/ausgabe.svelte"),
"./schluessel/bei-mir.svelte": () => import("./schluessel/bei-mir.svelte"),
"./schluessel/item.svelte": () => import("./schluessel/item.svelte"),
"./schluessel/manage.svelte": () => import("./schluessel/manage.svelte"),
"./telefon/anrufbeantworter.svelte": () => import("./telefon/anrufbeantworter.svelte"),
"./telefon/anrufe.svelte": () => import("./telefon/anrufe.svelte"),
"./telefon/debug.svelte": () => import("./telefon/debug.svelte"),
"./uploads/index.svelte": () => import("./uploads/index.svelte"),
"./user-authentication/account.svelte": () => import("./user-authentication/account.svelte"),
"./user-authentication/admin.svelte": () => import("./user-authentication/admin.svelte"),
"./user-authentication/elevate.svelte": () => import("./user-authentication/elevate.svelte"),
"./user-authentication/login.svelte": () => import("./user-authentication/login.svelte"),
"./vorgang/checklisten.svelte": () => import("./vorgang/checklisten.svelte"),
"./vorgang/email.svelte": () => import("./vorgang/email.svelte"),
"./vorgang/settings.svelte": () => import("./vorgang/settings.svelte"),
"./vorgang/vorgaenge.svelte": () => import("./vorgang/vorgaenge.svelte"),
"./DefaultMenu.svelte": () => import("./DefaultMenu.svelte"),
};

